import { serviceStatuses } from 'types/timetableServices';

const trainSwapApplicableServiceStatuses = [serviceStatuses.SEATING_CHANGED];

/**
 * Should the alert be shown for the given service?
 *
 * @param {Object} options
 * @param {TimetableService[]} options.timetableServices
 * @returns {boolean}
 */
export const shouldShowTrainSwapAlert = ({ timetableServices }) => {
  if (!timetableServices.length) {
    return false;
  }

  const [
    {
      model: { serviceStatus }
    }
  ] = timetableServices;

  return trainSwapApplicableServiceStatuses.includes(serviceStatus);
};

export const hasActiveAOP = (products) =>
  products?.some(
    ({ isCancelled, isActive, afterSalesCurrentOverrides, canBeRebooked }) =>
      afterSalesCurrentOverrides &&
      afterSalesCurrentOverrides.length > 0 &&
      afterSalesCurrentOverrides.some(({ type }) => type === 'REBOOK') &&
      canBeRebooked &&
      isActive &&
      !isCancelled
  );
